angular.module('iqxCore')
.controller('DoResetPasswordCtrl', function ($scope, FormSvc, $routeParams, $location, $timeout) {
  FormSvc.setOptions($scope,{
    fetchAPI:{},
    autoEdit:true,
    notLoggedIn:true
  })
  let code = ''

  $scope.fetchDecodedTokenAndValidate=function(){
    if($routeParams && $routeParams.code){
      code = decodeURIComponent($routeParams.code)      
      return $scope.fetch({
        fetchAPI:'callresult_/NetResetPassword?@token='+code,
        autoEdit:true,
        notLoggedIn:true
      })
      .then(function() {
        const now = moment()
        const timestamp = moment($scope.theRecord.WhenCreated)
        const codeValid = (now.diff(timestamp, 'h') < 24)
  
        if(codeValid === false){
          $location.path('/resetpassword')
          return FormSvc.alert('', 'Password reset has expired or is invalid, please request another password reset.', 'error')
        }     
      })
      .catch(function(){
        $location.path('/resetpassword')
        FormSvc.alert('', 'Password reset has expired or is invalid, please request another password reset.', 'error')
      })
    }

  }

  $scope.save = function(){
    $scope.setSubmitted(true)

    if(!$scope.theRecord.NewPassword || $scope.theRecord.NewPassword == ''){
      return FormSvc.alert('', 'Invalid Password.', 'error')
    }

    if($scope.theRecord.NewPassword !== $scope.theRecord.RepeatPassword){
      return FormSvc.alert('','Passwords do not match.', 'error')
    }
    $scope.theRecord.Token = code

    return $scope.exec('auth/changepassword',$scope.theRecord)
    .then(function(res){
      if(res.IQXResult.attrs.success && res.IQXResult.attrs.success === '1'){
        FormSvc.alert('Password change successful', 'You will be redirected to the login screen.', 'success')
        $timeout(function(){
          return $location.path('/login')
        }, 3000)
        
      } else {
        return FormSvc.alert('Error', 'There was a problem resetting your password, please try again.', 'error')
      }
    })
  }

  $scope.passwordOpts()
  $scope.fetch().then($scope.fetchDecodedTokenAndValidate())
})
